import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import UnifiedNavbar from '../components/UnifiedNavbar';
import AuthModal from '../components/AuthModal';
import InitialNamePrompt from '../components/InitialNamePrompt';
import { useNavbarConfig } from '../context/NavbarContext';
import { useAuthModal } from '../context/AuthModalContext';

// Lightweight inline fallback so the navbar stays visible while a lazy
// page chunk is still loading. A full-screen spinner here would flash
// over the shell and re-introduce the "blink" the user is trying to
// avoid — this blank block just reserves content height.
const OutletFallback = () => (
  <div style={{ minHeight: '100vh' }} aria-hidden="true" />
);

// MainLayout: persistent shell for all pages that share the UnifiedNavbar.
// The navbar (and the global AuthModal) are rendered exactly once here
// and never unmount during route changes — only the page content swaps.
// Pages opt into specific navbar behaviour via useSetNavbarConfig({...}).
export default function MainLayout() {
  const config = useNavbarConfig();
  const { openAuth } = useAuthModal();
  // Default Sign In on any page opens the global modal in place — no more
  // homepage round-trip. Pages can still override `onSignInClick` via
  // useSetNavbarConfig if they need bespoke behaviour.
  return (
    <>
      <UnifiedNavbar onSignInClick={() => openAuth()} {...config} />
      <Suspense fallback={<OutletFallback />}>
        <Outlet />
      </Suspense>
      <AuthModal />
      {/* One-time prompt for users with the auto-generated `User XXXX`
          placeholder name. Mounted globally so it appears whichever
          page the user lands on after signup. */}
      <InitialNamePrompt />
    </>
  );
}
